import { lazy, Suspense } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import BackToTop from "@/components/back-to-top";
import ScrollToTop from "@/components/scroll-to-top";
import { Toaster } from "sonner";
import Loading from "@/components/loading";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import News from "./pages/news";
import Canada from "./pages/canada";
import Australia from "./pages/australia";
import Usa from "./pages/usa";
import Uk from "./pages/uk";
import Denmark from "./pages/denmark";
import Newzealand from "./pages/newzealand";
import Newspage from "./pages/newspage";
import Homepage from "./pages/homepage";
import Addressmap from "./pages/addressmap";
import Canadaskilledmigrationvisa from "./pages/canada-skilled-migration-visa";
import Canadainvestorvisa from "./pages/canada-investor-visa";
import Canadastudentvisa from "./pages/canada-student-visa";
import Canadaworkingvisa from "./pages/canada-working-visa";
import Canadavisitvisa from "./pages/canada-visit-visa";
import Australiaskilledmigrationvisa from "./pages/australia-skilled-migration-visa";
import Australiainvestorvisa from "./pages/australia-investor-visa";
import Australiastudentvisa from "./pages/australia-student-visa";
import Australiaworkingvisa from "./pages/australia-working-visa";
import Australiavisitvisa from "./pages/australia-visit-visa";
import Usaemploymentbasedgreencard from "./pages/usa-employment-based-greencard";
import Usastudyvisa from "./pages/usa-study-visa";
import Usavisitvisa from "./pages/usa-visit-visa";
import Ukbusinessvisa from "./pages/uk-business-visa";
import Ukstudentvisa from "./pages/uk-student-visa";
import Ukvisitvisa from "./pages/uk-visit-visa";
import Denmarkdanishgreencard from "./pages/denmark-danish-greencard";
import Denmarkstudentvisa from "./pages/denmark-student-visa";
import Denmarkvisitvisa from "./pages/denmark-visit-visa";
import Newzealandskilledmigrationvisa from "./pages/newzealand-skilled-migration-visa";
import Newzealandinvestorvisa from "./pages/newzealand-investor-visa";
import Newzealandworkingvisa from "./pages/newzealand-working-visa";
import Newzealandstudentvisa from "./pages/newzealand-student-visa";
import Newzealandvisitvisa from "./pages/newzealand-visit-visa";
import Contacts from "./pages/contacts";
import Layout1 from "./components/Layout1";
import Blogs from "./pages/blogs";
import Canadablog from "./pages/canadablog";
import Australiablog from "./pages/australiablog";
import Usablog from "./pages/usablog";
import Ukblog from "./pages/ukblog";
import Denmarkblog from "./pages/denmarkblog";
import Newzelandblog from "./pages/newzelandblog";
import Admin from "./pages/admin";
import Visaworldlandingpage from "./pages/visaworldlandingpage";
import Privacypolicy from "./pages/privacypolicy";
// import Test_demo from "./pages/test-demo";

const Header = lazy(() => import("@/components/layout/header"));
const Footer = lazy(() => import("@/components/layout/footer"));
const HeaderLayout2 = lazy(() => import("@/components/layout/header-layout-2"));
const FooterLayout2 = lazy(() => import("@/components/layout/footer-layout-2"));

const HomeSEOAgency = lazy(() => import("./pages/home-seo-agency"));
// const HomeConsulting = lazy(() => import("./pages/homepage"));
const Schengenvisa = lazy(() => import("./pages/schengenvisa"));
const Blog = lazy(() => import("./pages/blog"));
const SinglePost = lazy(() => import("./pages/single-post"));
const SingleProject = lazy(() => import("./pages/single-project"));
const About = lazy(() => import("./pages/about"));
const Services = lazy(() => import("./pages/services"));
const Pricing = lazy(() => import("./pages/pricing"));
const Contact = lazy(() => import("./pages/contact"));
const NotFound = lazy(() => import("./pages/not-found"));
const queryClient = new QueryClient();

function App() {
  const location = useLocation();

  return (
    <>
      {/* <QueryClientProvider client={queryClient}>
        <Suspense fallback={<Loading />}>

          {location.pathname === "/consulting" ? <HeaderLayout2 /> : <Header />}
          <AnimatePresence mode="wait">

            <Layout1>
            <Routes location={location} key={location.pathname}>
              <Route index element={<Homepage  />} />
              <Route path="/seo-agency" element={<HomeSEOAgency />} />
              <Route path="/homepage" element={<Homepage />} />
              <Route path="/schengenvisa" element={<Schengenvisa />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/single-post" element={<SinglePost />} />
              <Route path="/single-project" element={<SingleProject />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<Services />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/news" element={<News />} />
              <Route path="/australia" element={<Australia />} />
              <Route path="/canada" element={<Canada />} />
              <Route path="/usa" element={<Usa />} />
              <Route path="/uk" element={<Uk />} />
              <Route path="/denmark" element={<Denmark />} />
              <Route path="/newzealand" element={<Newzealand />} />
              <Route path="/newspage" element={<Newspage />} />
              <Route path="/addressmap" element={<Addressmap />} />
              <Route path="/skilledmigrationvisa" element={<Skilledmigrationvisa />} />
              <Route path="/investorvisa" element={<Investorvisa />} />
              <Route path="/studentvisa" element={<Studentvisa />} />
              <Route path="/workingvisa" element={<Workingvisa />} />
              <Route path="/visitvisa" element={<Visitvisa />} />
              <Route path="/australiaskilledmigrationvisa" element={<Australiaskilledmigrationvisa />} />
              <Route path="/australiainvestorvisa" element={<Australiainvestorvisa />} />
              <Route path="/australiastudentvisa" element={<Australiastudentvisa />} />
              <Route path="/australiaworkingvisa" element={<Australiaworkingvisa />} />
              <Route path="/australiavisitvisa" element={<Australiavisitvisa />} />
              <Route path="/employmentbasedgreencard" element={<Employmentbasedgreencard />} />
              <Route path="/usastudyvisa" element={<Usastudyvisa />} />
              <Route path="/usavisitvisa" element={<Usavisitvisa />} />
              <Route path="/ukbusinessvisa" element={<Ukbusinessvisa />} />
              <Route path="/ukstudentvisa" element={<Ukstudentvisa />} />
              <Route path="/ukvisitvisa" element={<Ukvisitvisa />} />
              <Route path="/danishgreencard" element={<Danishgreencard />} />
              <Route path="/denmarkstudentvisa" element={<Denmarkstudentvisa />} />
              <Route path="/denmarkvisitvisa" element={<Denmarkvisitvisa />} />
              <Route path="/newzealandskilledmigrationvisa" element={<Newzealandskilledmigrationvisa />} />
              <Route path="/newzealandinvestorvisa" element={<Newzealandinvestorvisa />} />
              <Route path="/newzealandworkingvisa" element={<Newzealandworkingvisa />} />
              <Route path="/newzealandstudentvisa" element={<Newzealandstudentvisa />} />
              <Route path="/newzealandvisitvisa" element={<Newzealandvisitvisa />} />
              <Route path="/contacts" element={<Contacts />} />
              <Route path="/blogs" element={<Blogs />} />
              <Route path="/canadablog" element={<Canadablog />} />
              <Route path="/australiablog" element={<Australiablog />} />
              <Route path="/usablog" element={<Usablog />} />
              <Route path="/ukblog" element={<Ukblog />} />
              <Route path="/denmarkblog" element={<Denmarkblog />} />
              <Route path="/newzelandblog" element={<Newzelandblog />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/visaworldlandingpage" element={<Visaworldlandingpage />} />
            

              <Route path="*" element={<NotFound />} />
            </Routes>
            </Layout1>

          </AnimatePresence>
          {location.pathname === "/consulting" ? <FooterLayout2 /> : <Footer />}
          <Toaster richColors />
          <BackToTop />
          <ScrollToTop />
        </Suspense>
      </QueryClientProvider> */}
      <QueryClientProvider client={queryClient}>
        <Suspense fallback={<Loading />}>
          {/* Render header conditionally */}
          {location.pathname !== "/visaworldlandingpage" &&
            (location.pathname === "/consulting" ? (
              <HeaderLayout2 />
            ) : (
              <Header />
            ))}

          <AnimatePresence mode="wait">
            {location.pathname === "/visaworldlandingpage" ? (
              // Render Visaworldlandingpage independently
              <Routes location={location} key={location.pathname}>
                <Route
                  path="/visaworldlandingpage"
                  element={<Visaworldlandingpage />}
                />
              </Routes>
            ) : (
              // Render the rest of the application
              <Layout1>
                <Routes location={location} key={location.pathname}>
                  <Route index element={<Homepage />} />
                  <Route path="/seo-agency" element={<HomeSEOAgency />} />
                  <Route path="/homepage" element={<Homepage />} />
                  <Route path="/schengenvisa" element={<Schengenvisa />} />
                  <Route path="/blog" element={<Blog />} />
                  <Route path="/single-post" element={<SinglePost />} />
                  <Route path="/single-project" element={<SingleProject />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/services" element={<Services />} />
                  <Route path="/pricing" element={<Pricing />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/news" element={<News />} />
                  <Route path="/australia" element={<Australia />} />
                  <Route path="/canada" element={<Canada />} />
                  <Route path="/usa" element={<Usa />} />
                  <Route path="/uk" element={<Uk />} />
                  <Route path="/denmark" element={<Denmark />} />
                  <Route path="/newzealand" element={<Newzealand />} />
                  <Route path="/newspage" element={<Newspage />} />
                  <Route path="/addressmap" element={<Addressmap />} />
                  <Route
                    path="/canada-skilled-migration-visa"
                    element={<Canadaskilledmigrationvisa />}
                  />
                  <Route
                    path="/canada-investor-visa"
                    element={<Canadainvestorvisa />}
                  />
                  <Route
                    path="/canada-student-visa"
                    element={<Canadastudentvisa />}
                  />
                  <Route
                    path="/canada-working-visa"
                    element={<Canadaworkingvisa />}
                  />
                  <Route
                    path="/canada-visit-visa"
                    element={<Canadavisitvisa />}
                  />
                  <Route
                    path="/australia-skilled-migration-visa"
                    element={<Australiaskilledmigrationvisa />}
                  />
                  <Route
                    path="/australia-investor-visa"
                    element={<Australiainvestorvisa />}
                  />
                  <Route
                    path="/australia-student-visa"
                    element={<Australiastudentvisa />}
                  />
                  <Route
                    path="/australia-working-visa"
                    element={<Australiaworkingvisa />}
                  />
                  <Route
                    path="/australia-visit-visa"
                    element={<Australiavisitvisa />}
                  />
                  <Route
                    path="/usa-employment-based-greencard"
                    element={<Usaemploymentbasedgreencard />}
                  />
                  <Route path="/usa-study-visa" element={<Usastudyvisa />} />
                  <Route path="/usa-visit-visa" element={<Usavisitvisa />} />
                  <Route path="/uk-business-visa" element={<Ukbusinessvisa />} />
                  <Route path="/uk-student-visa" element={<Ukstudentvisa />} />
                  <Route path="/uk-visit-visa" element={<Ukvisitvisa />} />
                  <Route
                    path="/denmark-danish-greencard"
                    element={<Denmarkdanishgreencard />}
                  />
                  <Route
                    path="/denmark-student-visa"
                    element={<Denmarkstudentvisa />}
                  />
                  <Route
                    path="/denmark-visit-visa"
                    element={<Denmarkvisitvisa />}
                  />
                  <Route
                    path="/newzealand-skilled-migration-visa"
                    element={<Newzealandskilledmigrationvisa />}
                  />
                  <Route
                    path="/newzealand-investor-visa"
                    element={<Newzealandinvestorvisa />}
                  />
                  <Route
                    path="/newzealand-working-visa"
                    element={<Newzealandworkingvisa />}
                  />
                  <Route
                    path="/newzealand-student-visa"
                    element={<Newzealandstudentvisa />}
                  />
                  <Route
                    path="/newzealand-visit-visa"
                    element={<Newzealandvisitvisa />}
                  />
                  <Route path="/contacts" element={<Contacts />} />
                  <Route path="/blogs" element={<Blogs />} />
                  <Route path="/canadablog" element={<Canadablog />} />
                  <Route path="/australiablog" element={<Australiablog />} />
                  <Route path="/usablog" element={<Usablog />} />
                  <Route path="/ukblog" element={<Ukblog />} />
                  <Route path="/denmarkblog" element={<Denmarkblog />} />
                  <Route path="/newzelandblog" element={<Newzelandblog />} />
                  <Route path="/admin" element={<Admin />} />
                  <Route path="*" element={<NotFound />} />
                  <Route path="/privacypolicy" element={<Privacypolicy />} />
                  {/* <Route path="/test-demo" element={<Test_demo />} /> */}

                </Routes>
              </Layout1>
            )}
          </AnimatePresence>

          {/* Render footer conditionally */}
          {location.pathname !== "/visaworldlandingpage" &&
            (location.pathname === "/consulting" ? (
              <FooterLayout2 />
            ) : (
              <Footer />
            ))}

          <Toaster richColors />
          <BackToTop />
          <ScrollToTop />
        </Suspense>
      </QueryClientProvider>
    </>
  );
}

export default App;
